import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, ReplaySubject, first, switchMap, Observer, tap } from "rxjs";
import { Web3Service } from "../web3/web3.service";

@Injectable({
  providedIn: 'root'
})
export class CoinService {

  private _kmonPrice: ReplaySubject<IConversionCoin> = new ReplaySubject<IConversionCoin>(1);

  constructor(
    private http: HttpClient
  ) { }

  getKmonPrice(): Observable<IConversionCoin> {
    let ids: string[] = ['kryptomon', 'wbnb'];
    let vs_currencies: string[] = ['bnb', 'usd'];
    let precision: number = 18;
    return this.http.get<IConversionCoin>(
      environment.coingecko + `api/v3/simple/price?ids=${ids.toString()}&vs_currencies=${vs_currencies.toString()}&precision=${precision}`).pipe(
        tap(p => {
          this._kmonPrice.next(p);
        }));
  }

  get kmonPrice$(): Observable<IConversionCoin> {
    return this._kmonPrice.asObservable();
  }

  getKmonPriceGeneric(ids: string[] = ['kryptomon', 'wbnb'], vs_currencies: string[] = ['bnb', 'usd'], precision: number = 18): Observable<any> {
    return this.http.get(
      environment.coingecko + `api/v3/simple/price?ids=${ids.toString()}&vs_currencies=${vs_currencies.toString()}&precision=${precision}`);
  }

}


export interface IConversionCoin {
  kryptomon: {
    bnb: number
    usd: number
  }
  wbnb: {
    bnb: number
    usd: number
  }
}
/* 
response:
{
  "kryptomon": {
    "bnb": 0.000030329202351042,
    "usd": 0.006218258231373949
  },
  "wbnb": {
    "bnb": 0.999999537976996,
    "usd": 205.01789634458055
  }
}
 */